import request from "library/v1/request";

export function getTreatmentPlans(params) {
  return request({
    url: `treatment_plans`,
    method: 'get',
    cancelPrevious: true,
    params
  })
}

export function showTreatmentPlan(treatmentPlanId) {
  return request({
    url: `treatment_plans/${treatmentPlanId}`,
    method: 'get'
  })
}

export function generatePdf(treatmentPlanId) {
  return request({
    url: `treatment_plans/${treatmentPlanId}/generate_pdf`,
    method: 'put'
  })
}

export function drawSignatureOnTxpPdf(treatmentPlanId, data) {
  return request({
    url: `treatment_plans/${treatmentPlanId}`,
    method: 'patch',
    headers: {
      'Content-type': 'multipart/form-data',
    },
    data
  });
}

export function sendReceipt(treatmentPlanId, params) {
  return request({
    url: `treatment_plans/${treatmentPlanId}/send_receipt`,
    method: 'get',
    params
  })
}

export function createTreatmentPlanProgress(treatmentPlanId, data) {
  return request({
    url: `treatment_plans/${treatmentPlanId}/treatment_plan_progresses`,
    method: 'post',
    data
  })
}

export function getTreatmentPlanProgresses(treatmentPlanId) {
  return request({
    url: `treatment_plans/${treatmentPlanId}/treatment_plan_progresses`,
    method: 'get'
  });
}

export function updateTreatmentPlanProgress(treatmentPlanId, treatmentPlanProgressId, data) {
  return request({
    url: `treatment_plans/${treatmentPlanId}/treatment_plan_progresses/${treatmentPlanProgressId}`,
    method: 'put',
    data
  });
}
